import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';
import { APPEARANCES, SIZES } from './constants';
import { iconsList } from '../icon/glyphs';

const Tag = ({
  iconGlyph = null,
  appearance = APPEARANCES.accent,
  label = '',
  isLabelBold = false,
  size = SIZES.medium,
  onClick = null,
}) => {
  const classes = classNames('ws-ui-tag', `ws-ui-tag--${size}`, `ws-ui-tag--${appearance}`, {
    'ws-ui-tag--with-icon': iconGlyph && label,
    'ws-ui-tag--only-icon': iconGlyph && !label,
    'ws-ui-tag--with-hover': onClick,
  });

  return (
    <div className={classes} {...(onClick && { onClick })}>
      {iconGlyph && (
        <span className="ws-ui-tag__icon">
          <Icon glyph={iconGlyph} type="inherit" size="100%" strokeWidth={2} />
        </span>
      )}
      {label && <span className="ws-ui-tag__text">{isLabelBold ? <b>{label}</b> : label}</span>}
    </div>
  );
};

Tag.propTypes = {
  iconGlyph: PropTypes.oneOf(iconsList),
  label: PropTypes.string,
  isLabelBold: PropTypes.bool,
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  size: PropTypes.oneOf(Object.values(SIZES)),
  onClick: PropTypes.func,
};

export default Tag;
